module.exports = require('./helpers/bundle-url').getBundleURL('2av5d') + "volfova.2d60a804.jpg";